export enum PlatformType {
  Web = 'web',
  Desktop = 'desktop',
  Figma = 'figma',
  Sketch = 'sketch',
  Photoshop = 'photoshop',
  Illustrator = 'illustrator',
  iOSApp = 'ios-app'
}



// WEBPACK FOOTER //
// ./src/data/PlatformType.ts